import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './index.css';
import HomeConcours from './pages/HomeConcours';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import Pay from './pages/pay/Pay'
import Recrutement from './pages/Recrutement';
import ErrorPage from './components/Error';
import Recepisse from './components/RecepisseDepot';
import Connexion from "./pages/Connexion/Connexion";
import ContextWrapper from "./context/ContextWrapper";
import DashBoard from './pages/Dashbord/Dashboard';
import Concours from './pages/Concours';
import Home from './pages/Home';
import Update from './pages/Update';
import Nav from './components/Nav';
import Voyage from './pages/Voyage'
import Vacation from './pages/Vacation';
import Inscription from './pages/Inscription';
import HomeIns from './pages/HomeInscription';
import UpdateInscription from './pages/UpdateInscription';
import Erasmus from './pages/Erasmus';
import PayAdmission from './pages/PayAdmission/Pay';
import PayUniforme from './pages/PayUniforme/Pay';
import Admission from './pages/Admission';
import Restaurant from './pages/Restaurant/Restaurant';
import Inscription2 from './pages/Reinscription';
import Vote from './pages/Vote'
import Radius from './pages/Radius';
import RecrutementCiaq from "./pages/RecrutementCiaq";
import CepecEmail from './pages/CepecEmail';
import RecrutementPer from './pages/RecrutementPer';
import Footer from './components/Footer/Footer';
import UpdateRecrutement from './pages/UpdateRecrutement/UpdateRecrutement';
import UpdateVoyage from './pages/UpdateVoyage/UpdateVoyage';
import RedirectReinscription from './pages/RedirectReinscription';
import RecrutementOther from './pages/RecrutementOther';
import UpdateAdmission from './pages/Admission/update';
import Cames from './pages/cames';
import UpdateCames from './pages/cames/update';
import Recherches from './pages/Recherches';
import Etranger from './pages/Etranger';
import UpdateEtranger from './pages/Etranger/update';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
    {/* <Home /> */}

    <ContextWrapper>
        <Router>
            <Nav />
            <Routes>
                <Route path="/" element = {<Home />} />
                <Route path="/paiement" element = {<Pay />} />
                <Route path="/id" element = {<Recepisse />} />
                <Route path="/commande" element = {<Restaurant />} />
                <Route path="/concours" element = {<Pay />} />
                <Route path="/depot" element = {<Concours />} />
                {/* <Route path="/concours" element = {<ErrorPage errorCode="not-open" errorMessage={<>Le dépôt des candidatures se fait uniquement en ligne via ce lien <a href="https://depot.uam.sn/concours">https://depot.uam.sn/concours</a> qui sera disponible à partir du lundi 23 juillet jusqu'au jeudi 16 août 2026 à 23h59.</>} />} /> */}
                <Route path="/pay" element = {<PayAdmission />} />
                <Route path="/payment" element = {<PayUniforme />} />
                <Route path="/cepec/email" element = {<CepecEmail />} />
                <Route path="/candidature" element = {<Recrutement />} />
                <Route path="/certificat" element = {<RecrutementCiaq />} />
                <Route path="/recrutement" element = {<RecrutementOther />} />
                <Route path="/connexion" element = {<Connexion />} />
                <Route path="/update" element = {<Update />} />
                <Route path="/voyage" element = {<Voyage />} />
                <Route path="/voyage/:uid" element = {<UpdateVoyage />} />
                <Route path="/vote" element = {<Vote />} />
                <Route path="/erasmus" element = {<Erasmus />} />
                <Route path="/radius" element = {<Radius />} />
                <Route path="/vacation" element = {<Vacation />} />
                {/* <Route path="/admission" element = {<Etranger />} /> */}
                <Route path="/admission" element = {<Admission />} />
                <Route path="/inscription" element = {<Inscription />} />
                <Route path="/reinscription" element = {<Inscription2 />} />
                <Route path="/master" element = {<RedirectReinscription />} />
                <Route path="/homeInscription" element = {<HomeIns />} />
                <Route path="/updateInscription" element = {<UpdateInscription />} />
                <Route path="/dashboard/*" element = { <DashBoard />} />
                <Route path="/per" element = { <RecrutementPer />} />
                <Route path="/per/:uid" element={<UpdateRecrutement />} />
                <Route path='/admission/edit/:uid' element={<UpdateAdmission />} />
                <Route path='/cames' element={<Cames />} />
                <Route path='/cames/:uid' element={<UpdateCames />} />
                <Route path='/recherches' element={<Recherches />} />
                <Route path='/admission-etranger' element={<Etranger />} />
                <Route path='/admission-etranger/edit/:uid' element={<UpdateEtranger />} />
                <Route path='*' element={<ErrorPage />} />
            </Routes>
            <Footer />
        </Router>
    </ContextWrapper>


    </React.StrictMode>
);
reportWebVitals();
